import React,{useState,useEffect} from "react";
import Navbar from "./Navbar";
import axios from "axios";
import url from "../../function/url";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import Cookies from "js-cookie";
function Company_Highlight_Telecaller() {
    const ID = Cookies.get("log_id");
    const [requests,setRequests] = useState([]);
    const [payment,setPayment] = useState("");
    const [upiid,setUpiid] = useState("");
    const [amount,setAmount] = useState("");
    const [account,setAccount] = useState("");
    function Company_Requests() {
        axios.get(`${url.path}/company_requests_telecaller/${ID}/`)
        .then((res) =>{
            if(res.data.status){
                var cmp = res.data.company;
                    setRequests([])
                    cmp.map((c)=>{
                        setRequests((prevState) =>[
                            ...prevState, c
                        ])
                    })
            }
        }).catch((err) => {
            console.log("ERROR", err);
          });
    }
    useEffect(()=>{
        Company_Requests();
    },[])
    const itemsPerPage = 3;
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(0);

    const filteredData = requests.filter((item) =>
      item.Company_Name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const offset = currentPage * itemsPerPage;
    const currentItems = filteredData.slice(offset, offset + itemsPerPage);
    const pageCount = Math.ceil(filteredData.length / itemsPerPage);

    const handlePageClick = ({ selected }) => {
      setCurrentPage(selected);
    };
    function searchTable(){
      var rows = document.querySelectorAll('#productstable tbody tr');
      var val = document.getElementById('search').value.trim().replace(/ +/g, ' ').toLowerCase();
      rows.forEach(function(row) {
        var text = row.textContent.replace(/\s+/g, ' ').toLowerCase();
        row.style.display = text.includes(val) ? '' : 'none';
      });
    }
        const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
            },
        });
        const [selectedCompany,setSelectedCompany] = useState(false);
        const [company,setCompany] = useState(false);
        const [status,setStatus] = useState("");
        const [reason,setReason] = useState("");
        const handleOpenModal = (cmp) => {
            setSelectedCompany(cmp);
          };
          const handleCloseModal = () => {
            setSelectedCompany(null);
          };
          const ApprovalDisModal = (val,i) =>{
            var ab = val;
            var cmp = i;
            if (ab === 'Approved'){
                setCompany(cmp);
                setStatus(ab); 
            } else if (ab === 'Rejected'){
                setCompany(cmp);
                setStatus(ab);
            }
          };
          const closeApprovalDisModal = () =>{
            setCompany(null);
          };
        function handlePayment(pay) {
            var val = pay;
            if (val == 'UPI'){
                document.getElementById('upiDiv').style.display = 'flex';
                document.getElementById('accountDiv').style.display = 'none';
                setPayment(val);
            }else if (val == 'Net Banking'){
                document.getElementById('accountDiv').style.display = 'flex';
                document.getElementById('upiDiv').style.display = 'none';
                setPayment(val);
            }else {
              document.getElementById('accountDiv').style.display = 'none';
              document.getElementById('upiDiv').style.display = 'none';
              setPayment(null);
            }   
        }
        function SendPaymentLink(e) {
            e.preventDefault();
            const formdata = new FormData();
            formdata.append('id',ID);
            formdata.append('payment',payment);
            formdata.append('upiid',upiid);
            formdata.append('amount',amount);
            formdata.append('company',selectedCompany.id);
            formdata.append('account',account);
            axios.post(`${url.path}/send_payment_link/`,formdata)
            .then((res) =>{
                if(res.data.status){
                    Toast.fire({
                        icon:'success',
                        title:'Payment Link Send..'
                    })
                    Company_Requests();
                    handleCloseModal();
                }
            }).catch((err) => {
                console.log("ERROR", err);
              });
        }

        function handleSubmit(e) {
          e.preventDefault();
          const formdata = new FormData();
          formdata.append('id',ID);
          formdata.append('company',company.id);
          formdata.append('status',status);
          formdata.append('reason',reason);
          axios.post(`${url.path}/company_highlight_decision/`,formdata)
          .then((res) =>{
            if (res.data.status){
                if (res.data.stat === 'Approved'){
                    Toast.fire({
                      icon:'success',
                      title:'Company Highlight Request Accepted..'
                    })
                } else if (res.data.stat === 'Rejected'){
                  Toast.fire({
                    icon:'warning',
                    title:'Company Highlight Request Rejected..'
                  })
                }
                Company_Requests();
                closeApprovalDisModal();
            }
          }).catch((err) => {
            console.log("ERROR", err);
          });
        }
    return(
        <>
        <Navbar />
        <center>
            <h3 style={{fontSize:'20px',position:'relative',top:'10px'}}>Company Requests</h3>
            </center>
            <div className="search-container">
          <input
            type="text"
            placeholder="Search..."
            onKeyUp={searchTable}
            className="search-input"
            id="search"
          />
        </div>
        <div className="table-container">
            
      <table className="responsive-table" id="productstable">
        <thead>
          <tr>
            <th>Sl.No</th>
            <th>Company Name</th>
            <th>Position Desired</th>
            <th>From</th>
            <th>To</th>
            <th>Payment</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {requests.map((i,index) => (
            <tr key={i.id}>
              <td>{index+1}</td>
              <td>{i.Company_Name}</td>
              <td>{i.Position}</td>
              <td>{i.From_Date}</td>
              <td>{i.To_Date}</td>
              {i.Payment_Mode ? (
                <td><button type="button" style={{width:'80px',backgroundColor:'blue',color:'white',borderRadius:'5px'}} disabled>Payed</button></td>
              ) : (
                <td><button type="button" style={{width:'80px',backgroundColor:'blue',color:'white',borderRadius:'5px'}} onClick={() => handleOpenModal(i)}>Payment</button></td>
              )}
              
              <td>
              {i.Payment_Status ? (
                <button type="button" style={{width:'80px',backgroundColor:'green',color:'white',borderRadius:'5px'}} onClick={() => ApprovalDisModal("Approved",i)}>Approve</button>
                ) : (
                  <button type="button" style={{width:'80px',backgroundColor:'green',color:'white',borderRadius:'5px'}} disabled>Approve</button>
                )}
                
              <button type="button" style={{width:'100px',backgroundColor:'red',color:'white',borderRadius:'5px',marginLeft:'5px'}} onClick={() => ApprovalDisModal("Rejected",i)}>Reject</button></td>
                    
            </tr>
          ))}
        </tbody>
      </table>
      {filteredData.length > itemsPerPage && (
        <ReactPaginate
          previousLabel={"← Previous"}
          nextLabel={"Next →"}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      )}
    </div>
    {selectedCompany && (
    <div className="modal-overlay" onClick={handleCloseModal}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="close-button"
          onClick={handleCloseModal}
        >
          &times;
        </button>
        <h2>Send Payment Link</h2>
        
        <form onSubmit={SendPaymentLink}>
            <div className="from-group-row">
                <div className="form-group">
                    <label>Select Payment Method</label>
                    <select value={payment} onChange={(e) =>handlePayment(e.target.value)}>
                        <option value="" selected>--Select--</option>
                        <option value="UPI">UPI</option>
                        <option value="Net Banking">Net Banking</option>
                    </select>
                </div>
                <div className="form-group" style={{display:'none'}} id="upiDiv">
                    <label>UPI ID</label>
                    <input type="text" value={upiid} onChange={(e) =>setUpiid(e.target.value)} />
                </div>
                <div className="form-group" style={{display:'none'}} id="accountDiv">
                    <label>Account No</label>
                    <input type="text" value={account} onChange={(e) =>setAccount(e.target.value)} />
                </div>
                <div className="form-group">
                    <label>Amount</label>
                    <input type="text" value={amount} onChange={(e) =>setAmount(e.target.value)} />
                </div>
            </div>
          <center>
          <button type="submit" style={{width:'100px',backgroundColor:'gainsboro',borderRadius:'5px'}}>Send</button>
          </center>
        </form>
      </div>
    </div>
  )}
  {company && (
    <div className="modal-overlay" onClick={closeApprovalDisModal}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="close-button"
          onClick={closeApprovalDisModal}
        >
          &times;
        </button>
        <h2>Company Request Decision</h2>
        <form onSubmit={handleSubmit}>
          {status === 'Rejected' ? (
            <div className="form-group-row"  id="requestDiv">
            <div className="form-group" >
              <label>Reason</label>
              <input type="text" value={reason} onChange={(e) =>setReason(e.target.value)} />
            </div>
          </div>
          ): null}
          <center>
          <button type="submit" style={{width:'100px',backgroundColor:'gainsboro',borderRadius:'5px'}}>Submit</button>
          </center>
        </form>
      </div>
    </div>
  )}
        </>
    );
}
export default Company_Highlight_Telecaller;